import { Link } from "react-router-dom";
import { formatViews, getVideoTypeName, type VideoItem } from "@/lib/content";

export default function VideoCard({ item }: { item: VideoItem }) {
  return (
    <Link
      to={`/video/${item.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100 transition-colors hover:border-accent-400/60"
    >
      <div className="relative h-44 w-full overflow-hidden">
        <img
          src={item.cover}
          alt={`${item.title} - 视频封面`}
          title={`${item.title} - 91.con娱乐视频`}
          className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 flex items-center justify-center bg-background-50/20 opacity-0 transition-opacity group-hover:opacity-100">
          <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-500/90">
            <i className="ri-play-fill text-2xl text-background-50"></i>
          </span>
        </div>
        <span className="absolute bottom-3 right-3 rounded-sm bg-background-50/85 px-2 py-0.5 text-xs font-medium text-foreground-950">
          {item.duration}
        </span>
        {item.hot && (
          <span className="absolute left-3 top-3 flex items-center gap-1 rounded-sm bg-accent-500 px-2 py-0.5 text-xs font-medium text-background-50">
            <i className="ri-fire-fill"></i>热门
          </span>
        )}
      </div>
      <div className="flex flex-1 flex-col p-4">
        <div className="mb-2 flex flex-wrap items-center gap-2 text-xs">
          <span className="rounded-sm bg-secondary-500/20 px-2 py-0.5 font-medium text-secondary-300">
            {getVideoTypeName(item.type)}
          </span>
          {item.tags.slice(0, 1).map((t) => (
            <span key={t} className="rounded-sm bg-accent-500/20 px-2 py-0.5 font-medium text-accent-300">
              {t}
            </span>
          ))}
        </div>
        <h3 className="line-clamp-2 font-heading text-base font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-accent-400">
          {item.title}
        </h3>
        <div className="mt-auto flex items-center gap-4 pt-4 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            {item.date}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-play-line"></i>
            {formatViews(item.views)}
          </span>
        </div>
      </div>
    </Link>
  );
}